import { render } from "./SystemSettingsList.vue?vue&type=template&id=25491651&scoped=true"
import script from "./SystemSettingsList.vue?vue&type=script&lang=js"
export * from "./SystemSettingsList.vue?vue&type=script&lang=js"

import "./SystemSettingsList.vue?vue&type=style&index=0&id=25491651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25491651"]])

export default __exports__